//EditValuesIBM.tsx ==============================================================
import "../Util/Prototypes";

import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as MainMap from "../MainMap";
import * as Settings from "../Settings";
import * as SignIn_Auth0 from "../Util/SignIn_Auth0";
import * as SnackBar from "../Util/SnackBar";
import * as Spinner from "../Util/Spinner";
import * as TextField_IBM from "./TextField_IBM";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";
import * as Widgets from "../Widgets/Widgets";

import { Button, Icon, IconButton, Paper, Typography } from "@mui/material";

import { deepOrange, lightBlue, red, yellow } from '@mui/material/colors';

import Axios, { AxiosResponse } from "axios";

import React from "react";

const toolName: string = "Edit";

export let activePIN: string;
//Setters.
export function setActivePIN(activePIN_in: string) {
   activePIN = activePIN_in;
}

let saveDisabled: boolean;
let uniqueID: string;     // To force refresh when a new parcel is selected.
let uniqueLandID: string; // To force refresh of land values when total land value is changed.
let startingUp: boolean;

const reason_values: string[] = [ //Not used yet.
   "A|Countywide equalization of assessments based on current market value",
   "B|New building completed prior year",
   "C|New building completed prior year where other buildings previously assessed",
   "D|New improvement other than building completed prior year",
   "E|Addition to existing building",
   "F|Renovation of existing building",
   "G|New lot or acreage tract",
   "H|Lot or parcel size increase or decrease",
   "I|Property Combined",
   "J|Property subdivided",
   "K|Property status changed from tax exempt to taxable",
   "L|Property status changed from taxable to exempt",
   "M|Ratio Change",
   "N|Error correction - most recent notice in error, Assessor correcting error by this notice",
   "O|Use value change to market value",
   "P|Market value change to use value",
   "Q|Building demolished prior year",
   "R|Request for Review - No Change in Assessor's previous value",
   "S|Request for Review - Change shown as made by Assessor",
   "T|Request for Review - No Change in Assessor's value by the Board of Assessment of Appeals",
   "U|Request for Review - Change shown as made by the Board of Assessment of Appeals",
   "V|Receiving Developer's Discount",
   "W|Change from Developer's Discount to Market Value",
   "X|Property Value Review by Assessor",
   "Y|ATI - Assessable Transfer of Interest",
   "Z|Combination of any of the above reasons"];
let reason: string = reason_values[0];

//Set reason labels.
let reason_labels: string[];
setReasons();

function setReasons() {
   let i: number;
   reason_labels = [];
   for (i = 0; i < reason_values.length; i++) {
      reason_labels.push(reason_values[i].replace("|", " - "));
   }
}

//Web service interface.
export interface iCurrentValuesIBM {

   //Improvement values.
   residence?: number;
   residenceOrig?: number;

   other?: number;
   otherOrig?: number;

   agriculture?: number;
   agricultureOrig?: number;

   agUse?: number;
   agUseOrig?: number;

   mobileHome?: number; //4% tax ration.
   mobileHomeOrig?: number;

   mobileHome6?: number; //6% tax ratio.
   mobileHome6Orig?: number;

   //Land values.
   residenceLand?: number;
   residenceLandOrig?: number;
   residenceLandAcre?: number;

   otherLand?: number;
   otherLandOrig?: number;
   otherLandAcre?: number;

   agricultureLand?: number;
   agricultureLandOrig?: number;
   agricultureLandAcre?: number;

   agUseLand?: number;
   agUseLandOrig?: number;

   agUseLand6?: number;
   agUseLand6Orig?: number;

   totalLand?: number;
   totalLandOrig?: number;

   //Pickup improvement values.
   residencePickup?: number;
   otherPickup?: number;
   agriculturePickup?: number;
   agUsePickup?: number;
   mobileHomePickup?: number;
   mobileHome6Pickup?: number; //6% tax ratio.

   //Total values.
   capLand?: number;
   capImp?: number;
   capTotal?: number;

   taxLand?: number;
   taxImp?: number;
   taxTotal?: number;

   marketLand?: number;
   marketImp?: number;
   marketTotal?: number;

   //Last reassessment taxable values.
   taxLand_reMast?: number;
   taxImp_reMast?: number;
   taxTotal_reMast?: number;

   //Mobile home specific.
   mobileHomeNo?: string;
   lotNum?: string;
   sqFt?: number;
   mhDescription?: string;
   mhPicture?: string;
   hasEdits?: boolean;

   //Miscelaneous.
   doneFlag?: boolean;
   dateChanged?: string;
   initials?: string;
   tripleSplit?: boolean;
   errMsg?: string;
}
let curData: iCurrentValuesIBM = {};

//String version of data.
interface iStringData {

   //Improvement values.
   residenceAny?: string;
   otherAny?: string;
   agricultureAny?: string;
   agUseAny?: string;
   mobileHomeAny?: string;
   mobileHome6Any?: string;

   //Land values.
   residenceLandAny?: string;
   otherLandAny?: string;
   agricultureLandAny?: string;
   agUseLandAny?: string;
   agUseLand6Any?: string;
   totalLandAny?: string;

   //Pickup values.
   residencePickupAny?: string;
   otherPickupAny?: string;
   agriculturePickupAny?: string;
   agUsePickupAny?: string;
   mobileHomePickupAny?: string;
   mobileHome6PickupAny?: string;
}

const s: iStringData = {};

//Get string value.
function getStringValue(inValue: any): string {
   let outValue: string = Util.formatTextValue(inValue, "Comma");
   if (outValue === "0") {
      outValue = "";
   }
   return outValue;
}

//Round to nearest 100.
function nearest100(inValue: number): number {
   return Util.parseInteger(((inValue + 50) / 100).toString()) * 100;
}

//Get initials by user name.
export function getUserInitials(userName: string): string {
   let initials: string = "";
   if (userName === "bbarnell") {
      initials = "BB";

   } else if (userName === "kbanks") {
      initials = "KB";

   } else if (userName === "jyoung") {
      initials = "JY";

   } else if (userName === "ebayless") {
      initials = "EB";

   } else if (userName === "lhammett") {
      initials = "LH";

   } else if (userName === "rivey") {
      initials = "RI";
   }
   return initials;
}

//Refresh the map.
export function refreshMap() {
   const mapLayer: any = MainMap.map.findLayerById("Reassessment Status");
   if (mapLayer) {
      mapLayer.refresh();
   }
}

interface iProps {
}

//Render function.
export function Render(props: iProps) {
   //Util.logMsg("Top of Edit Render");

   if (DrawerMenu.curToolName === "") {
      return (<div />);
   }

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Wire up component for each time render is called, but not on refresh.
   const [initComponent, setState] = React.useState(() => {
      startingUp = true;

      //Get current values from IBM server.
      const ajaxData: Default.iAjaxData = { action: "getCurrentValuesIBM", pinList: [activePIN] };

      const webAPI_path = Util_App.getWebAPI_path();

      Axios.post(webAPI_path, ajaxData)
         .then(function (response) {

            if (!response) {
               Util.errMsg("ajax results from server are null");
               return;
            }
            if (response.data.errMsg !== "") {
               SnackBar.show(response.data.errMsg);
               return;
            }

            curData = response.data;
            uniqueID = Util.uid();
            uniqueLandID = uniqueID;
            saveDisabled = true;

            //Market improvements and last reassessment taxable detail values.
            s.residenceAny = getStringValue(curData.residence);
            s.otherAny = getStringValue(curData.other);
            s.agricultureAny = getStringValue(curData.agriculture);
            s.agUseAny = getStringValue(curData.agUse);
            s.mobileHomeAny = getStringValue(curData.mobileHome);
            s.mobileHome6Any = getStringValue(curData.mobileHome6);

            //Total land value.
            curData.totalLand = curData.residenceLand + curData.otherLand + curData.agricultureLand;

            //Market land and last reassessment taxable detail values.
            s.residenceLandAny = getStringValue(curData.residenceLand);
            s.otherLandAny = getStringValue(curData.otherLand);
            s.agricultureLandAny = getStringValue(curData.agricultureLand);
            s.agUseLandAny = getStringValue(curData.agUseLand);
            s.agUseLand6Any = getStringValue(curData.agUseLand6);
            s.totalLandAny = getStringValue(curData.totalLand);

            //Pickups.
            s.residencePickupAny = getStringValue(curData.residencePickup);
            s.otherPickupAny = getStringValue(curData.otherPickup);
            s.agriculturePickupAny = getStringValue(curData.agriculturePickup);
            s.agUsePickupAny = getStringValue(curData.agUsePickup);
            s.mobileHomePickupAny = getStringValue(curData.mobileHomePickup);
            s.mobileHome6PickupAny = getStringValue(curData.mobileHome6Pickup);

            startingUp = false;
            refresh();
         })
         .catch(function (error) {
            Spinner.hide();
            Util.errMsg("ajax error setting IBM values.", error);
         });
   });

   //Component did mount.
   React.useEffect(() => {
   }, []);

   //Component did update.
   React.useEffect(() => {
      Widgets.setPosition();
   });

   //Close this tool.
   function close() {
      DrawerMenu.closeTool();
   }

   //Market or pickup value changed.
   function valueChanged(fieldCode: string, value: number) {
      //Util.logMsg("valueChanged fieldCode, inValue: " + fieldCode + " " + value);

      //Improvements.
      if (fieldCode === "Residential") {
         curData.residence = value;

      } else if (fieldCode === "Other 6%") {
         curData.other = value;

      } else if (fieldCode === "Agricultural 6%") {
         curData.agriculture = value;

      } else if (fieldCode === "Agricultural Use") {
         curData.agUse = value;

      } else if (fieldCode === "Mobile Home") {
         curData.mobileHome = value;

      } else if (fieldCode === "Mobile Home 6%") {
         curData.mobileHome6 = value;

         //Land.
      } else if (fieldCode === "Residential Land") {
         curData.residenceLand = value;

      } else if (fieldCode === "Other Land 6%") {
         curData.otherLand = value;

      } else if (fieldCode === "Agricultural Land 6%") {
         curData.agricultureLand = value;

      } else if (fieldCode === "Agricultural Use Land") {
         curData.agUseLand = value;

      } else if (fieldCode === "Agricultural Use Land 6%") {
         curData.agUseLand6 = value;

      } else if (fieldCode === "Total Land") {
         const totAcre: number = curData.residenceLandAcre + curData.otherLandAcre + curData.agricultureLandAcre;

         if (curData.residenceLandAcre > 0) {
            curData.residenceLand = nearest100(value * (curData.residenceLandAcre / totAcre));
            s.residenceLandAny = getStringValue(curData.residenceLand);
         }
         if (curData.otherLandAcre > 0) {
            curData.otherLand = nearest100(value * (curData.otherLandAcre / totAcre));
            s.otherLandAny = getStringValue(curData.otherLand);
         }
         if (curData.agricultureLandAcre > 0) {
            curData.agricultureLand = nearest100(value * (curData.agricultureLandAcre / totAcre));
            s.agricultureLandAny = getStringValue(curData.agricultureLand);
         }
         uniqueLandID = Util.uid();  //Refresh the land details because total land value has changed.

         //Pickups.
      } else if (fieldCode === "Residential Pickup") {
         curData.residencePickup = value;

      } else if (fieldCode === "Other 6% Pickup") {
         curData.otherPickup = value;

      } else if (fieldCode === "Agricultural 6% Pickup") {
         curData.agriculturePickup = value;

      } else if (fieldCode === "Agricultural Use Pickup") {
         curData.agUsePickup = value;

      } else if (fieldCode === "Mobile Home Pickup") {
         curData.mobileHomePickup = value;

      } else if (fieldCode === "Mobile Home 6% Pickup") {
         curData.mobileHome6Pickup = value;
      }

      curData.hasEdits = true;
      saveDisabled = false;
      refresh();
   }

   //Recalculate totals.
   function calcTotalValues() {

      //Pickup value total computation.
      const pickUpTotal: number = curData.residencePickup + curData.otherPickup + curData.agriculturePickup + curData.agUsePickup + curData.mobileHomePickup + curData.mobileHome6Pickup;

      //Market value totals computation.
      curData.marketLand = curData.residenceLand + curData.otherLand + curData.agricultureLand;
      curData.marketImp = curData.residence + curData.other + curData.agriculture + curData.agUse + curData.mobileHome + curData.mobileHome6 + pickUpTotal;
      curData.marketTotal = curData.marketLand + curData.marketImp;

      curData.marketLand = nearest100(curData.marketLand);
      curData.marketImp = nearest100(curData.marketImp);
      curData.marketTotal = nearest100(curData.marketTotal);

      //Cap value totals computation.
      curData.capLand = curData.taxLand_reMast * 1.15;
      curData.capImp = (curData.taxImp_reMast + pickUpTotal) * 1.15;
      curData.capTotal = (curData.taxTotal_reMast + pickUpTotal) * 1.15;
      const capTotal: number = curData.capTotal;

      curData.capLand = nearest100(curData.capLand);
      curData.capImp = nearest100(curData.capImp);
      curData.capTotal = nearest100(curData.capTotal);

      //Reduce cap if greater than unrounded value.
      if (curData.capTotal > capTotal) {
         curData.capTotal -= 100;

         if ((curData.capLand + curData.capImp) > curData.capTotal) {
            if (curData.capImp >= curData.capLand) {
               curData.capImp = curData.capTotal - curData.capLand;
            } else {
               curData.capLand = curData.capTotal - curData.capImp;
            }
         }
      }

      //Taxable value totals computation.
      curData.taxLand = curData.marketLand;
      curData.taxImp = curData.marketImp;
      curData.taxTotal = curData.marketTotal;

      if (curData.marketTotal > curData.capTotal) {
         curData.taxLand = curData.capLand;
         curData.taxImp = curData.capImp;
         curData.taxTotal = curData.capTotal;
      }
   }

   //Reason for changed.
   function reasonChanged(event: any) {
      reason = event.target.value;
      refresh();
   }

   //Save values.
   function saveValues() {
      if (Spinner.busy) {
         return; //Quit if busy.
      }
      Spinner.show();

      //Send market, pickup, and all total values to server.
      const ajaxData: Default.iAjaxData = { action: "saveAppraisedValuesIBM", userName: SignIn_Auth0.userName, reAssData: [curData], pinList: [activePIN] };

      const webAPI_path = Util_App.getWebAPI_path();

      Axios.post(webAPI_path, ajaxData)
         .then(function (response) {
            setTimeout(function () { Spinner.hide(); }, 500); //Wait to avoid fumble finger multiple clicks.

            if (!response) {
               Util.errMsg("ajax results from server are null");
               return;
            }
            if (response.data.errMsg !== "") {
               SnackBar.show(response.data.errMsg);
               return;
            }
            SnackBar.show("Successfully changed improvement values", 2);
            saveDisabled = true;
            curData.doneFlag = true;
            curData.initials = getUserInitials(SignIn_Auth0.userName);
            curData.dateChanged = new Date().ToShortDate();
            refreshMap();
            refresh();
         })
         .catch(function (error) {
            Spinner.hide();
            Util.errMsg("ajax error setting IBM values.", error);
         });
   }

   //Set the reassessment done flag.
   function setDone() {
      if (Spinner.busy) {
         return; //Quit if busy.
      }
      Spinner.show();
      const ajaxData: Default.iAjaxData = { action: "setDoneIBM", userName: SignIn_Auth0.userName, pinList: [activePIN] };

      const webAPI_path = Util_App.getWebAPI_path();

      Axios.post(webAPI_path, ajaxData)
         .then(function (response) {
            setTimeout(function () { Spinner.hide(); }, 500); //Wait to avoid fumble finger multiple clicks.

            if (!response) {
               Util.errMsg("ajax results from server are null");
               return;
            }
            if (response.data.errMsg !== "") {
               SnackBar.show(response.data.errMsg);
               return;
            }
            SnackBar.show("Successfully set reassessement done", 2);
            curData.doneFlag = true;
            curData.initials = getUserInitials(SignIn_Auth0.userName);
            curData.dateChanged = new Date().ToShortDate();
            refreshMap();
            refresh();
         })
         .catch(function (error) {
            Spinner.hide();
            Util.errMsg("ajax error setting IBM values.", error);
         });
   }

   //Quit if starting up.
   if (startingUp) {
      return (<div />);
   }

   //Calculate total values.
   calcTotalValues();

   //String version of totals.
   const pickUpTot: number = curData.residencePickup + curData.otherPickup + curData.agriculturePickup + curData.agUsePickup + curData.mobileHomePickup + curData.mobileHome6Pickup;
   const pickUpTotalStr: string = getStringValue(pickUpTot);

   const marketLandStr: string = getStringValue(curData.marketLand);
   const marketImpStr: string = getStringValue(curData.marketImp);
   const marketTotalStr: string = getStringValue(curData.marketTotal);

   const capLandStr: string = getStringValue(curData.capLand);
   const capImpStr: string = getStringValue(curData.capImp);
   const capTotalStr: string = getStringValue(curData.capTotal);

   const taxLandStr: string = getStringValue(curData.taxLand);
   const taxImpStr: string = getStringValue(curData.taxImp);
   const taxTotalStr: string = getStringValue(curData.taxTotal);

   //Done or not done.
   let doneDisabled: boolean = false;
   let doneText: string = "Not done";
   let initialsText: string = "";
   let dateChangedText: string = "";
   let byText: string = "";
   let onText: string = "";

   if (curData.doneFlag) {
      doneDisabled = true;
      doneText = "Done";
      initialsText = curData.initials;
      dateChangedText = curData.dateChanged;
      byText = "By: ";
      onText = "On: ";
   }

   //Show total land value edit box.
   let numLandAcres: number = 0;
   if (curData.residenceLandAcre > 0) {
      numLandAcres++;
   }
   if (curData.otherLandAcre > 0) {
      numLandAcres++;
   }
   if (curData.agricultureLandAcre > 0) {
      numLandAcres++;
   }
   let showEditTotalLand: boolean = false;
   if (numLandAcres > 1) {
      showEditTotalLand = true;
   }

   //Tooltips.
   const landTip: string = "Real Estate Master Taxable: " + curData.taxLand_reMast;
   const impTip: string = "Real Estate Master Taxable: " + curData.taxImp_reMast;
   const totalTip: string = "Real Estate Master Taxable: " + curData.taxTotal_reMast;
   const pickUpTotalTip: string = "Total Pickups: " + pickUpTotalStr;

   const scrollDivID: string = toolName.replace(" ", "_") + "_Scroll";

   //Styles.
   const styles: any = {
      pinStyle: { backgroundColor: yellow[100], padding: 3, marginLeft: 7, marginRight: 40, fontWeight: 500, fontSize: Settings.detailsFontSize },
      miscStyle: { color: deepOrange[900], fontWeight: 500, fontSize: Settings.detailsFontSize },
      table: { width: '100%', fontWeight: 500, overflowX: 'auto', border: '1px solid silver', borderCollapse: 'collapse', marginTop: 9, marginBottom: 9, fontFamily: 'Roboto, Helvetica, Arial, Verdana' },
      body: { cursor: 'default' },

      headingTitleCell: { color: lightBlue.A700, backgroundColor: Settings.headingColor, fontWeight: 500, textAlign: 'center', padding: 3, fontSize: Settings.detailsFontSize },
      headingCell: { backgroundColor: Settings.headingColor, fontWeight: 500, textAlign: 'center', padding: 3, fontSize: Settings.detailsFontSize },
      highlight: { backgroundColor: yellow[600], fontWeight: 500, textAlign: 'center', padding: 3, fontSize: Settings.detailsFontSize },

      bodyCellLeft: { padding: 3, textAlign: 'left', backgroundColor: Settings.leftPanelLabelColor, color: 'black', fontSize: Settings.detailsFontSize, borderTop: '1px solid silver' },
      bodyCellRight: { backgroundColor: Settings.leftPanelLabelColor, textAlign: 'right', padding: 3, fontSize: Settings.detailsFontSize, borderTop: '1px solid silver' },
      bodyCellTotal: { color: deepOrange[900], borderTop: '1px solid silver', backgroundColor: Settings.leftPanelLabelColor, textAlign: 'right', padding: 3, fontSize: Settings.detailsFontSize },

      tripSplit: { color: 'white', backgroundColor: red.A400, fontWeight: 500, padding: 5, marginRight: 4 },
   };

   //Background colors.
   let marketBackground: any = styles.highlight;
   let capBackground: any = styles.headingCell;
   if (curData.marketTotal > curData.capTotal) {
      marketBackground = styles.headingCell;
      capBackground = styles.highlight;
   }

   return (
      <Paper>
         <div style={Default.styles.appToolHeading}>
            <Typography variant="body1" style={{ marginLeft: 12 }}>
               {curData.tripleSplit && <span style={styles.tripSplit}>Triple Split !</span>}
               PIN:<span style={styles.pinStyle}>{activePIN}</span><span style={styles.miscStyle}>{doneText}</span>
               &nbsp;&nbsp;&nbsp;&nbsp;{byText}<span style={styles.miscStyle}>{initialsText}</span>
               &nbsp;&nbsp;&nbsp;&nbsp;{onText}<span style={styles.miscStyle}>{dateChangedText}</span>
            </Typography>

            <IconButton color="primary" onClick={close} title="Close" aria-label="Close" >
               <Icon>close</Icon>
            </IconButton>
         </div>

         <div id={scrollDivID} style={{ overflow: "auto" }}>
            <div className="app-flex-column-start" style={{ padding: 9, paddingBottom: 0 }}>

               <table style={styles.table}>
                  <thead>
                     <tr tabIndex={-1}>
                        <th style={styles.headingTitleCell}>Land</th>
                        <th style={styles.headingCell}>Last</th>
                        <th style={styles.headingCell}>Market</th>
                        <th style={styles.headingCell}>Change</th>
                     </tr>
                  </thead>

                  <tbody style={styles.body}>
                     <TextField_IBM.Render
                        id="ResidenceLand-id"
                        uid={uniqueLandID}
                        fieldCode="Residential Land"
                        orig={curData.residenceLandOrig}
                        value={curData.residenceLand}
                        valueAny={s.residenceLandAny}
                        onChange={valueChanged}
                     />

                     <TextField_IBM.Render
                        id="OtherLand-id"
                        uid={uniqueLandID}
                        fieldCode="Other Land 6%"
                        orig={curData.otherLandOrig}
                        value={curData.otherLand}
                        valueAny={s.otherLandAny}
                        onChange={valueChanged}
                     />

                     <TextField_IBM.Render
                        id="AgricultureLand-id"
                        uid={uniqueLandID}
                        fieldCode="Agricultural Land 6%"
                        orig={curData.agricultureLandOrig}
                        value={curData.agricultureLand}
                        valueAny={s.agricultureLandAny}
                        onChange={valueChanged}
                     />

                     <TextField_IBM.Render
                        id="AgUseLand-id"
                        uid={uniqueID}
                        fieldCode="Agricultural Use Land"
                        orig={curData.agUseLandOrig}
                        value={curData.agUseLand}
                        valueAny={s.agUseLandAny}
                        onChange={valueChanged}
                     />

                     <TextField_IBM.Render
                        id="AgUseLand6-id"
                        uid={uniqueID}
                        fieldCode="Agricultural Use Land 6%"
                        orig={curData.agUseLand6Orig}
                        value={curData.agUseLand6}
                        valueAny={s.agUseLand6Any}
                        onChange={valueChanged}
                     />
                     {showEditTotalLand && <TextField_IBM.Render
                        id="TotalLand-id"
                        uid={uniqueID}
                        fieldCode="Total Land"
                        orig={curData.totalLandOrig}
                        value={curData.totalLand}
                        valueAny={s.totalLandAny}
                        onChange={valueChanged}
                     />}
                  </tbody>
               </table>

               <table style={styles.table}>
                  <thead>
                     <tr tabIndex={-1}>
                        <th style={styles.headingTitleCell}>Improvements</th>
                        <th style={styles.headingCell}>Last</th>
                        <th style={styles.headingCell}>Market</th>
                        <th style={styles.headingCell}>Change</th>
                        <th style={styles.headingCell} title={pickUpTotalTip}>Pickups</th>
                     </tr>
                  </thead>

                  <tbody style={styles.body}>

                     <TextField_IBM.Render
                        id="Residence-id"
                        uid={uniqueID}
                        fieldCode="Residential"
                        orig={curData.residenceOrig}
                        value={curData.residence}
                        valueAny={s.residenceAny}
                        valuePickup={curData.residencePickup}
                        valuePickupAny={s.residencePickupAny}
                        onChange={valueChanged}
                     />

                     <TextField_IBM.Render
                        id="Other-id"
                        uid={uniqueID}
                        fieldCode="Other 6%"
                        orig={curData.otherOrig}
                        value={curData.other}
                        valueAny={s.otherAny}
                        valuePickup={curData.otherPickup}
                        valuePickupAny={s.otherPickupAny}
                        onChange={valueChanged}
                     />

                     <TextField_IBM.Render
                        id="Agriculture-id"
                        uid={uniqueID}
                        fieldCode="Agricultural 6%"
                        orig={curData.agricultureOrig}
                        value={curData.agriculture}
                        valueAny={s.agricultureAny}
                        valuePickup={curData.agriculturePickup}
                        valuePickupAny={s.agriculturePickupAny}
                        onChange={valueChanged}
                     />

                     <TextField_IBM.Render
                        id="AgUse-id"
                        uid={uniqueID}
                        fieldCode="Agricultural Use"
                        orig={curData.agUseOrig}
                        value={curData.agUse}
                        valueAny={s.agUseAny}
                        valuePickup={curData.agUsePickup}
                        valuePickupAny={s.agUsePickupAny}
                        onChange={valueChanged}
                     />

                     <TextField_IBM.Render
                        id="MobileHome-id"
                        uid={uniqueID}
                        fieldCode="Mobile Home"
                        orig={curData.mobileHomeOrig}
                        value={curData.mobileHome}
                        valueAny={s.mobileHomeAny}
                        valuePickup={curData.mobileHomePickup}
                        valuePickupAny={s.mobileHomePickupAny}
                        onChange={valueChanged}
                     />

                     <TextField_IBM.Render
                        id="MobileHome6-id"
                        uid={uniqueID}
                        fieldCode="Mobile Home 6%"
                        orig={curData.mobileHome6Orig}
                        value={curData.mobileHome6}
                        valueAny={s.mobileHome6Any}
                        valuePickup={curData.mobileHome6Pickup}
                        valuePickupAny={s.mobileHome6PickupAny}
                        onChange={valueChanged}
                     />
                  </tbody>
               </table>

               <table style={styles.table}>
                  <thead>
                     <tr tabIndex={-1}>
                        <th style={styles.headingTitleCell}>Summary</th>
                        <th style={marketBackground}>Market</th>
                        <th style={capBackground}>Cap</th>
                        <th style={styles.headingCell}>Taxable</th>
                     </tr>
                  </thead>

                  <tbody style={styles.body}>
                     <tr tabIndex={-1}>
                        <td style={styles.bodyCellLeft}>Land</td>
                        <td style={styles.bodyCellRight}>{marketLandStr}</td>
                        <td style={styles.bodyCellRight}>{capLandStr}</td>
                        <td style={styles.bodyCellRight} title={landTip}>{taxLandStr}</td>
                     </tr>
                     <tr tabIndex={-1}>
                        <td style={styles.bodyCellLeft}>Improvements</td>
                        <td style={styles.bodyCellRight}>{marketImpStr}</td>
                        <td style={styles.bodyCellRight}>{capImpStr}</td>
                        <td style={styles.bodyCellRight} title={impTip}>{taxImpStr}</td>
                     </tr>
                     <tr tabIndex={-1}>
                        <td style={styles.bodyCellLeft}>Total</td>
                        <td style={styles.bodyCellRight}>{marketTotalStr}</td>
                        <td style={styles.bodyCellRight}>{capTotalStr}</td>
                        <td style={styles.bodyCellTotal} title={totalTip}>{taxTotalStr}</td>
                     </tr>

                  </tbody>
               </table>

               <div className="app-flex-row-around" style={{ padding: 7 }}>
                  <Button style={{ marginRight: 60 }} disabled={doneDisabled} variant="contained" size="medium" color="primary" onClick={setDone} title="Set reassessment done">
                     Done
                  </Button>

                  <Button disabled={saveDisabled} variant="contained" size="medium" color="primary" onClick={saveValues} title="Save all values">
                     Save
                  </Button>
               </div>

            </div>
         </div>
      </Paper>
   ); //end return.

} //end function.
